// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Attention from '../_raw/ui/icon_attention.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Attention);
